import { useState, useEffect, useRef } from 'react';
import { LOG_LEVEL_ERROR, LOG_SOURCE_FE_REQUEST_FAILED, REQUEST_FAILED_LOG_TEMPLATE } from '../constants/logs';
import { isRequestCanceled, sendLogToKibana, toLoggableRequestError } from '../utilities/logs';

/** @deprecated - dont use any mutation api */
export const useMutationApi = requestFunction => {
  const [response, setResponse] = useState(null);
  const [errorResponse, setErrorResponse] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Used to prevent state update if the component is unmounted
  const cancelRequest = useRef(false);

  const successHandler = res => {
    if (cancelRequest.current) return;
    setResponse(res);
    setStatusCode(res.statusCode);
    setIsSuccess(true);
    setIsError(false);
    return res;
  };

  const failureHandler = err => {
    if (cancelRequest.current) return;
    if (isRequestCanceled(err)) throw err;
    if (err?.response) {
      setErrorResponse(err.response);
      setStatusCode(err.response?.status);
    }
    setIsSuccess(false);
    setIsError(true);
    const error = toLoggableRequestError(err);
    sendLogToKibana({
      template: REQUEST_FAILED_LOG_TEMPLATE,
      params: [error.method, error.url, error.status ?? error.code],
      extraParams: { error },
      logLevel: LOG_LEVEL_ERROR,
      source: LOG_SOURCE_FE_REQUEST_FAILED,
      responseCode: error.status
    });
    throw err;
  };

  const fetchData = (body = {}, ...args) => {
    setIsLoading(true);
    setIsError(false);
    setIsSuccess(false);
    return requestFunction(body, ...args)
      .then(successHandler)
      .catch(failureHandler)
      .finally(() => setIsLoading(false));
  };

  const resetState = () => {
    setStatusCode(null);
    setErrorResponse(null);
    setResponse(null);
    setIsLoading(false);
    setIsError(false);
    setIsSuccess(false);
  };

  useEffect(
    () =>
      // Use the cleanup function for avoiding a possibly...
      // ...state update after the component was unmounted
      // Pay attention, this will not work as expected in dev mode (hot reload/code replacement will invoke it.
      () => {
        cancelRequest.current = true;
      },
    []
  );

  return [
    fetchData,
    { data: response, errorData: errorResponse, isSuccess, isError, isLoading, statusCode },
    resetState
  ];
};
